'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _util = require('@arreeba/ristoranti-lib/lib/util');

var _merchant = require('@arreeba/ristoranti-lib/lib/action/merchant');

var _merchant2 = _interopRequireDefault(_merchant);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _extends({}, _merchant2.default, (0, _util.createActionObject)('loadConfiguration', _constants.LOAD_APP_CONFIGURATION_START, _constants.LOAD_APP_CONFIGURATION_SUCCESS, _constants.LOAD_APP_CONFIGURATION_FAILURE), (0, _util.createActionObject)('loadMerchantInfo', _constants.LOAD_MERCHANT_INFO_START, _constants.LOAD_MERCHANT_INFO_SUCCESS, _constants.LOAD_MERCHANT_INFO_FAILURE), (0, _util.createActionObject)('loadBookingRushes', _constants.LOAD_BOOKING_RUSHES_START, _constants.LOAD_BOOKING_RUSHES_SUCCESS, _constants.LOAD_BOOKING_RUSHES_FAILURE), (0, _util.createActionObject)('verifyRecoveryToken', _constants.VERIFY_RECOVERY_TOKEN_START, _constants.VERIFY_RECOVERY_TOKEN_SUCCESS, _constants.VERIFY_RECOVERY_TOKEN_FAILURE), (0, _util.createActionObject)('resetPassword', _constants.RESET_PASSWORD_START, _constants.RESET_PASSWORD_SUCCESS, _constants.RESET_PASSWORD_FAILURE), {
  updateConnectionInfo: function updateConnectionInfo(info) {
    return {
      type: _constants.UPDATE_CONNECTION_INFO,
      info: info
    };
  },
  updateUserLocation: function updateUserLocation(location) {
    return {
      type: _constants.USER_LOCATION,
      location: location
    };
  },
  resetRecoveryPasswordState: function resetRecoveryPasswordState() {
    return {
      type: _constants.RESET_RECOVERY_PASSWORD_STATUS
    };
  },
  updateRecoveryFormValue: function updateRecoveryFormValue(value) {
    return {
      type: _constants.UPDATE_RECOVERY_FORM_VALUE,
      value: value
    };
  },
  setRecoveryToken: function setRecoveryToken(token) {
    return {
      type: _constants.SET_RECOVERY_TOKEN,
      token: token
    };
  },
  setRecoveryEmailSent: function setRecoveryEmailSent() {
    return {
      type: _constants.RECOVERY_EMAIL_REQUEST
    };
  },


  // just for staging
  switchBundleId: function switchBundleId(bundleId) {
    return {
      type: _constants.SWITCH_BUNDLE_ID,
      newBundleId: bundleId
    };
  },
  switchApiEndpoint: function switchApiEndpoint(endpoint) {
    return {
      type: _constants.SWITCH_API_ENDPOINT,
      endpoint: endpoint
    };
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-frontend-lib/lib/actions/app.js
// module id = 408
// module chunks = 0